/**
 * wql
 * @description 证书挂靠管理列表
 * @Date  2020/9/18
 */
import React from "react";
import { connect } from "dva";
import { templateConfig, reduxTemplateCofig } from "./config";
import { handleExportHeader } from '@/utils/handleTabelHeaderUtils';

import { component_tool, framework_tool } from '../../../tool';
import SelectLinkOrg from './selectLinkOrg'
let { WizContainer, WizReduxTemplate } = framework_tool;
let { WizBrowserExport,WizSpin } = component_tool;


class CertLinkList extends WizContainer {
  componentName = 'personalCertList';
  constructor(props) {
    super(props);
    this.state = {
      selectedOrgLinkRows: [],//选择的学员
      orgLinkRecord: {},
      showUserPersonInfoVisible: false,
    }
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }


  _exportTrainPathInfo(nextProps, nextState, key) {
    let response = nextProps[key]
    const blob =response['result'];
    let link = document.createElement('a');
    let body = document.querySelector('body');

    link.href = window.URL.createObjectURL(blob);
    link.download = '证书挂靠记录.xls';

    // fix Firefox
    link.style.display = 'none';
    body.appendChild(link);

    link.click();
    body.removeChild(link);
    // if (o['success']) {
    //   let dataList = o.data
    //   dataList.forEach(e=>{
    //     if (e.userState == 1){
    //       e.userState = '激活';
    //     }else {
    //       e.userState = '禁用';
    //     }
    //     if (e.allowUnite == 0){
    //       e.allowUnite = '否';
    //     }else {
    //       e.allowUnite = '是';
    //     }
    //     if (e.state == 0){
    //       e.state = '正常';
    //     }else if(e.state == 1){
    //       e.state = '待确认';
    //     }else if(e.state == 2){
    //       e.state = '无';
    //     }
    //   })
    //   let columnDefs = [
    //     {
    //       headerName: '',
    //       width: 30,
    //       field: 'rowIndex',
    //       hidden: true,
    //       suppressMovable: true,
    //       cellStyle: {
    //         textAlign: 'center',
    //         padding: '5px 0',
    //         color: '#595959',
    //         backgroundColor: '#f0f0f0',
    //         display: 'inline-flex',
    //         alignItems: 'center',
    //         justifyContent: 'center',
    //         fontWeight: '500',
    //         boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
    //       },
    //     },
    //     {
    //       headerName: '姓名',
    //       field: 'fullName',
    //       width: 20,
    //       cellStyle: {
    //         textAlign: 'center',
    //       },
    //       style: {
    //         alignment: { vertical: 'bottom', horizontal: 'left' },
    //       },
    //     },
    //     {
    //       headerName: '账号',
    //       field: 'userName',
    //       width: 30,
    //       cellStyle: {
    //         textAlign: 'center',
    //       },
    //       style: {
    //         alignment: { vertical: 'bottom', horizontal: 'left' },
    //       },
    //     },
    //     {
    //       headerName: '身份证号/工号',
    //       field: 'idCard',
    //       width: 30,
    //       cellStyle: {
    //         textAlign: 'center',
    //       },
    //       style: {
    //         alignment: { vertical: 'bottom', horizontal: 'left' },
    //       },
    //     },
    //     {
    //       headerName: '账号状态',
    //       field: 'userState',
    //       width: 20,
    //       cellStyle: {
    //         textAlign: 'center',
    //       },
    //       style: {
    //         alignment: { vertical: 'bottom', horizontal: 'left' },
    //       },
    //     },
    //     {
    //       headerName: '证书名称',
    //       field: 'certName',
    //       width: 20,
    //       cellStyle: {
    //         textAlign: 'center',
    //       },
    //       style: {
    //         alignment: { vertical: 'bottom', horizontal: 'left' },
    //       },
    //     },
    //     {
    //       headerName: '是否允许共建',
    //       field: 'allowUnite',
    //       width: 20,
    //       cellStyle: {
    //         textAlign: 'center',
    //       },
    //       style: {
    //         alignment: { vertical: 'bottom', horizontal: 'left' },
    //       },
    //     },
    //     {
    //       headerName: '获得途径',
    //       field: 'channel',
    //       width: 20,
    //       cellStyle: {
    //         textAlign: 'center',
    //       },
    //       style: {
    //         alignment: { vertical: 'bottom', horizontal: 'left' },
    //       },
    //     },
    //     {
    //       headerName: '获得时间',
    //       field: 'certDate',
    //       width: 20,
    //       cellStyle: {
    //         textAlign: 'center',
    //       },
    //       style: {
    //         alignment: { vertical: 'bottom', horizontal: 'left' },
    //       },
    //     },
    //     {
    //       headerName: '导入时间',
    //       field: 'recordCreateTime',
    //       width: 20,
    //       cellStyle: {
    //         textAlign: 'center',
    //       },
    //       style: {
    //         alignment: { vertical: 'bottom', horizontal: 'left' },
    //       },
    //     },
    //     {
    //       headerName: '所属状态',
    //       field: 'state',
    //       width: 20,
    //       cellStyle: {
    //         textAlign: 'center',
    //       },
    //       style: {
    //         alignment: { vertical: 'bottom', horizontal: 'left' },
    //       },
    //     },
    //     {
    //       headerName: '所属组织名称',
    //       field: 'orgName',
    //       width: 20,
    //       cellStyle: {
    //         textAlign: 'center',
    //       },
    //       style: {
    //         alignment: { vertical: 'bottom', horizontal: 'left' },
    //       },
    //     },
    //     {
    //       headerName: '组织编码',
    //       field: 'orgCode',
    //       width: 20,
    //       cellStyle: {
    //         textAlign: 'center',
    //       },
    //       style: {
    //         alignment: {vertical: 'bottom', horizontal: 'left'},
    //       },
    //     },
    //     {
    //       headerName: '品牌',
    //       field: 'brandName',
    //       width: 20,
    //       cellStyle: {
    //         textAlign: 'center',
    //       },
    //       style: {
    //         alignment: {vertical: 'bottom', horizontal: 'left'},
    //       },
    //     },
    //     {
    //       headerName: '区域',
    //       field: 'regionName',
    //       width: 20,
    //       cellStyle: {
    //         textAlign: 'center',
    //       },
    //       style: {
    //         alignment: { vertical: 'bottom', horizontal: 'left' },
    //       },
    //     },
    //     {
    //       headerName: '是否共建店',
    //       field: 'dealerUnite',
    //       width: 20,
    //       cellStyle: {
    //         textAlign: 'center',
    //       },
    //       style: {
    //         alignment: { vertical: 'bottom', horizontal: 'left' },
    //       },
    //     }
    //   ]
    //   WizBrowserExport({
    //     title: '证书挂靠',
    //     sheetName: '证书挂靠',
    //     columns: columnDefs.filter((_, index) => index),
    //     rows: dataList,
    //     filename: '证书挂靠.xlsx',
    //   })
    //   return true;
    // } else {
    //   wizNotice.error(o['msg'])
    //   return false;
    // }
  }

  // _getPathContent(nextProps, nextState, key) {
  //   let o = nextProps[key]
  //   if (o['success']) {
  //     let title = o.data.title
  //     let dataList = o.data['dataList']
  //     let headList = o.data['headList']
  //     WizBrowserExport({
  //       title: title,
  //       sheetName: '路径内容',
  //       columns: handleExportHeader(headList).filter((_, index) => index),
  //       rows: dataList,
  //       filename: '路径内容.xlsx',
  //     })
  //
  //     return true;
  //   } else {
  //     wizNotice.error(o['msg'])
  //     return false;
  //   }
  // }


  /**
   * 获取查看组织挂靠任职信息
   * @param orgLinkRecord
   * @private
   */
  _showUserPersonModal = (orgLinkRecord) => {
    this.setState({
      orgLinkRecord: orgLinkRecord,
      showUserPersonInfoVisible: true,
    })
  };


  _render() {
    const { showUserPersonInfoVisible, orgLinkRecord } = this.state;
    let _templateConfig = templateConfig({
      onSelect: (keys, rows) => {
        this.setState({
          selectedOrgLinkRows: rows,
          selectedRows: rows.length,
          data: new Date().getTime(),
          rows: rows
        });
      },
      _this: this,
      _btnLookUserFun: (e) => {
        if (e.record) {
          let orgLinkRecord = e.record;
          this._showUserPersonModal(orgLinkRecord);
        }
      }
    });

    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig: _templateConfig,
      apiDataFormat: {
        enable: this._handleCMD,
        export: this._exportTrainPathInfo,
        getPathContent:this._getPathContent,
        updateState: this._handleCMD,
        del: this._handleCMD
      },
    })

    let orgLinkRow = orgLinkRecord && orgLinkRecord.length ? orgLinkRecord[0]:{};
    let lookUserPersonInfoModal = {
      title: '选择所属组织',
      visible: showUserPersonInfoVisible,
      personId: orgLinkRow.personId ? orgLinkRow.personId : null,
      orgId: orgLinkRow.orgId ? orgLinkRow.orgId : null,
      positionId: orgLinkRow.positionId ? orgLinkRow.positionId : null,
      userName: orgLinkRow.userName ? orgLinkRow.userName : null,
      fullName: orgLinkRow.fullName ? orgLinkRow.fullName : null,
      certName: orgLinkRow.certName ? orgLinkRow.certName : null,
      certType: orgLinkRow.type ? orgLinkRow.type : null,
      certId: orgLinkRow.certId ? orgLinkRow.certId : null,
      id: orgLinkRow.id ? orgLinkRow.id : null,
      onCancel: (e) => {
        this.setState({
          showUserPersonInfoVisible: false,
          orgLinkRecord: {},
        });
      },
    };

    return (
      <>
        <WizReduxTemplate  {..._reduxTemplateCofig} />
        <SelectLinkOrg {...lookUserPersonInfoModal} />
      </>
    )

  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(CertLinkList);
